const APP = {
	name: 'iBrush HTML Starter'
};